var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[(!_vm.loading && _vm.role)?_c('div',[_c('router-view',{attrs:{"role":_vm.role}})],1):_c('div',[_c('Loading',{attrs:{"message":"Loading partner details..."}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }